<template>
  <el-form
    :model="ruleForm2"
    :rules="rules2"
    ref="ruleForm2"
    label-position="left"
    label-width="0px"
    class="demo-ruleForm login-container"
    autocomplete="on"
  >
    <h3 class="title">Weplay</h3>
    <!-- 账号输入框（支持自动填充） -->
    <el-form-item prop="username">
      <el-input
        type="text"
        v-model="ruleForm2.username"
        autocomplete="username"
        name="username"
        placeholder="Tài Khoản"
      ></el-input>
    </el-form-item>
    <!-- 密码输入框（支持自动填充，保留星号显示） -->
    <el-form-item prop="password">
      <el-input
        type="password"
        v-model="ruleForm2.password"
        autocomplete="current-password"
        name="password"
        class="no-autofill-pwd"
        placeholder="Mật Khẩu"
      ></el-input>
    </el-form-item>
    <el-checkbox v-model="checked" class="remember">  Lưu mật khẩu </el-checkbox>
    <el-form-item style="width: 100%">
      <el-button
        type="primary"
        style="width: 100%"
        @click.native.prevent="handleSubmit2"
        :loading="logining"
        >Đăng Nhập</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import { loginApi } from "../utils/api";
export default {
  data() {
    return {
      logining: false,
      ruleForm2: {
        username: "",
        password: "",
      },
      rules2: {
        username: [{ required: true, message: "Nhập tài khoản", trigger: "blur" }],
        password: [{ required: true, message: "Nhập mật khẩu", trigger: "blur" }],
      },
      checked: true,
    };
  },
  mounted() {
    // 加载记住的账号密码
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (userInfo) {
      this.ruleForm2 = userInfo;
    }
  },
  methods: {
    handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },

    handleSubmit2(ev) {
      ev.preventDefault(); // 阻止默认表单提交
      const _this = this;

      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          this.logining = true;
          const loginParams = {
            username: this.ruleForm2.username,
            password: this.ruleForm2.password,
          };

          loginApi(loginParams).then((data) => {
            this.logining = false;
            if (data.code !== 200) {
              this.$message.error(data.msg);
              return;
            }

            // 存储登录状态和权限
            localStorage.setItem("token", data.data.token);
            localStorage.setItem("username", data.data.username);
            _this.$router.push({ path: "/table" });
            // 处理记住密码
            if (this.checked) {
              localStorage.setItem("userInfo", JSON.stringify(this.ruleForm2));
            } else {
              localStorage.removeItem("userInfo");
            }
          });
        } else {
          this.$message.error("Vui lòng điền đầy đủ thông tin tài khoản và mật khẩu");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login-container {
  border-radius: 5px;
  background-clip: padding-box;
  margin: 180px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;

  .title {
    margin: 0 auto 40px;
    text-align: center;
    color: #505458;
  }

  .remember {
    margin: 0 0 35px;
  }

  // 保留密码星号显示，兼容自动填充
  .no-autofill-pwd {
    /deep/ .el-input__inner {
      -webkit-text-security: disc !important;
    }
  }
}
</style>